import BusinessSearchResults from './BusinessSearchResults';

export default BusinessSearchResults;
